export default __webpack_public_path__ + "static/media/home-background.37e5c599.jpg";